import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptHashtags } from "../adapters/adaptHashtags";

const fetchAdminHashtags = async () => {
	const response = await cmsClient.get<IAdminHashtag[]>(
		"/homepage/admin/hashtags/"
	);

	return response.data;
};

const useAdminHashtags = () => {
	const query = useQuery(["admin-hashtags"], fetchAdminHashtags, {
		select: adaptHashtags
	});

	return query;
};

export default useAdminHashtags;
